// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"ac7285c8","453":"b4bffb52","463":"fa801caa","527":"11a789e9","553":"b1fcb269","858":"ca30fb62"}[chunkId] + ".chunk.js";
};